import React, { useCallback, useContext } from 'react';
import { useLocation } from '@thd-olt-component-react/router';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import {
  useDataModel, params, string, number, shape, arrayOf, extend
} from '@thd-nucleus/data-sources';

import { ProductResultsSearchMethodsPLP } from '../utils/product-results-search-methods-PLP';
import { ResultsFilterAndSortDrawer } from '../components/ResultsFilterAndSortDrawer';
import { ProductResultsSearchMethodsPEP } from '../utils/product-results-search-methods-PEP';
import { usePlpResultsHeaderReadyEvent } from '../hooks/usePlpResultsHeaderReadyEvent';

export const ResultsFilterAndSortDrawerComposable = () => {
  const { onDimensionsChangePEP, onSortChangePEP } = ProductResultsSearchMethodsPEP();
  const { onSortChangePLP, onDimensionsChangePLP } = ProductResultsSearchMethodsPLP();
  // viewPrimaryFilters flag is always true it is feature switch
  const viewPrimaryFilters = true;
  const viewAllFilterButton = useConfigService('fs-prop:isViewAllFilterButtonEnabled');
  const isPlpSpeedEnabled = useConfigService('fs-prop:isPlpSpeedEnabled');
  const { pathname, search } = useLocation();
  const path = `${pathname}${search}`;
  const { customContext, channel } = useContext(ExperienceContext);
  const { variables = {}, isConsumerApp, pageType } = customContext || {};
  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables?.keyword && !variables?.navParam
  };
  const { data = {}, loading, variables: dataModelVariables } = useDataModel('searchModel', defaultOptions);
  const { metadata } = data?.searchModel || {};
  const { contentType } = metadata || {};
  const isCategory = contentType === 'categorypage';
  const scrollTargetRef = usePlpResultsHeaderReadyEvent();
  // Prepare query variables and page context for the component
  const queryVariables = dataModelVariables || variables;
  const pageContext = { pageType };

  const onDimensionsChangeInternal = useCallback(({ refinement }) => {
    if (pageType === 'pep') {
      return onDimensionsChangePEP({ refinement, scrollTargetRef });
    }
    return onDimensionsChangePLP({
      refinement,
      viewPrimaryFilters,
    });
  }, [viewPrimaryFilters, onDimensionsChangePLP, onDimensionsChangePEP]);

  const handleSortChange = useCallback((sortParams) => {
    if (pageType === 'pep') {
      return onSortChangePEP({ ...sortParams, path });
    }
    return onSortChangePLP({ ...sortParams, path });
  }, [path, onSortChangePLP, onSortChangePEP]);

  if (isCategory && !viewPrimaryFilters) return null;

  return (
    <>
      {channel === 'mobile' ? (
        <ResultsFilterAndSortDrawer
          enableMultiStore={!isConsumerApp}
          onDimensionsChange={onDimensionsChangeInternal}
          onSortChange={handleSortChange}
          stickyOffset={59}
          isGetItFastOnPlp
          isPlpSpeedEnabled={isPlpSpeedEnabled}
          searchModelData={data}
          loading={loading}
          queryVariables={queryVariables}
          pageContext={pageContext}
          disableStickyFilter
          excludePickUpToday
        />
      ) : (
        <ResultsFilterAndSortDrawer
          onSortChange={handleSortChange}
          onDimensionsChange={onDimensionsChangeInternal}
          disableStickyFilter
          excludePickUpToday
          hideViewAll={!viewAllFilterButton}
          isPlpSpeedEnabled={isPlpSpeedEnabled}
          searchModelData={data}
          loading={loading}
          queryVariables={queryVariables}
          pageContext={pageContext}
        />
      )}
    </>
  );
};

ResultsFilterAndSortDrawerComposable.displayName = 'ResultsFilterAndSortDrawerComposable';

ResultsFilterAndSortDrawerComposable.dataModel = extend({
  searchModel: params({ keyword: string(), navParam: string(), storeId: string() }).shape({
    metadata: shape({
      contentType: string(),
      h1Tag: string()
    })
  })
}, ResultsFilterAndSortDrawer?.dataModel || {});
